import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import LeistungDetail from "@/pages/LeistungDetail";

// Secondary routes: code-split so the home LCP bundle stays lean.
// Leistungen + LeistungDetail stay eager: Suspense fallback (50vh empty)
// caused large CLS and delayed LCP on /leistungen/:slug.
const UeberUns = lazy(() => import("@/pages/UeberUns"));
const Team = lazy(() => import("@/pages/Team"));
const Impressum = lazy(() => import("@/pages/Impressum"));
const Datenschutz = lazy(() => import("@/pages/Datenschutz"));
const AGB = lazy(() => import("@/pages/AGB"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function PageFallback() {
  return (
    <div
      className="page-route-fallback"
      aria-hidden="true"
      style={{ minHeight: "50vh", background: "var(--brand-cream, #f7f4ec)" }}
    />
  );
}

function LazyPages() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Outlet />
    </Suspense>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/leistungen/:slug" element={<LeistungDetail />} />
          <Route element={<LazyPages />}>
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/team" element={<Team />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
